import { BranchInfoData } from "../BranchInfoData";
export class BranchInfo extends BranchInfoData {
    constructor(branchInfo) {
        super(branchInfo);
    }
    equals(branchInfo) {
        return this.ID === branchInfo.ID &&
            this.Name === branchInfo.Name &&
            this.RankID === branchInfo.RankID &&
            this.TotalLiveCount === branchInfo.TotalLiveCount;
    }
}
//# sourceMappingURL=BranchInfo.js.map